import LojaModel from "../../model/LojaModel";
import ObaPromocaoModel, { ObaTipoPromocaoEnum } from "../../model/ObaPromocaoModel";
import ProdutoModel from "../../model/ProdutoModel";
import LogUtil from "../../util/LogUtil";
import C5LojaDAO from "../C5/C5LojaDAO";
import C5ProdutoDAO from "../C5/C5ProdutoDAO";
import ProxyBaseDAO from "./ProxyBaseDAO";

class ProxyPromocaoDAO extends ProxyBaseDAO {
  private static instance: ProxyPromocaoDAO;
  private endpoint = `${this.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ProxyPromocaoDAO {
    if (!ProxyPromocaoDAO.instance) {
        ProxyPromocaoDAO.instance = new ProxyPromocaoDAO();
    }
    return ProxyPromocaoDAO.instance;
  }

  public async getPromocoes(loja: LojaModel): Promise<ObaPromocaoModel[]> {
    return [{
        id: 1,
        tipo: ObaTipoPromocaoEnum.DESCONTO,
        produtos: [
          "6639",
          "6773",
          "1644",
          "1898",
          "6119",
          "140",
          "4027",
          "4074",
          "6678",
          "6342",
          "153",
          "6375",
          "6385",
          "6701",
          "5289",
          "5290",
          "15",
          "2158",
          "6431",
          "5519",
          "5455",
          "4226",
          "4227",
          "4228",
          "6461",
          "6462",
          "6463",
          "6706",
          "2315",
          "2300",
          "5442",
          "5443",
          "2265",
          "2197",
          "2313",
          "5514",
          "5474",
          "6454",
          "5487",
          "2320",
          "2321",
          "2322",
          "2323",
          "2324",
          "2379",
          "2380",
          "2698",
          "2381",
          "2382",
          "2434",
          "2435",
          "2436",
          "2437",
          "2438",
          "2439",
          "4281",
          "194",
          "2619",
          "2614",
          "5753",
          "5754",
          "6611",
          "2505",
          "6742",
          "4444",
          "4445",
          "6606",
          "5702",
          "5703",
          "6570",
          "6571",
          "4503",
          "6019",
          "6042",
          "6043",
          "6044",
          "6045",
          "6046",
          "6047",
          "6762",
          "6763",
          "6764",
          "7015",
          "7012",
          "7329",
          "7345",
          "7344",
          "7641",
          "6766",
          "7487",
          "7710",
          "7711",
          "6819",
          "7654",
          "7655",
          "7656",
          "7657",
          "7658",
          "7667",
          "7668",
          "7669",
          "7670",
          "7554",
          "7718",
          "7533",
          "7754",
          "7755",
          "7758",
          "7759",
          "1406",
          "1834",
          "1805",
          "4757"
        ],
        de: new Date(2020, 10, 27),
        ate: new Date(2020, 11, 1),
        lojas: await C5LojaDAO.getInstance().getAll(),
    } as ObaPromocaoModel];
  }
  async getProdutos(loja: LojaModel, promocaoId: number): Promise<ProdutoModel[]> {
    const promocao = (await this.getPromocoes(loja)).find(p => p.id === promocaoId);
    
    if (promocao) {
      const arrProdutos: ProdutoModel[] = [];
      const arrProms: any = [];
      for (const prod of promocao.produtos) {
        arrProms.push(C5ProdutoDAO.getInstance().getById(prod, loja.lojaId).then(produto => {
          if (produto) {
            arrProdutos.push(produto);
          }
        }).catch(ex => {
          LogUtil.logEvento('PromocaoErroCarregarProduto', { ex, prod });
        }));
      }
      return Promise.allSettled(arrProms).then(() => {
        return arrProdutos;
      });
    } else {
      return [];
    }
  }
}

export default ProxyPromocaoDAO;